


import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
// import axios from "axios";
import axios from "../../../context/axios";
const RegionExplorer = () => {
  const [activeRegion, setActiveRegion] = useState(null);
  const [regionTours, setRegionTours] = useState([]);
  const [regions, setRegions] = useState([]);

  // Fetch tours based on active region ID
  useEffect(() => {
    const fetchToursByRegion = async () => {
      if (!activeRegion) return;
      try {
        const response = await axios.post("/tours/by-region-id", {
          regionId: activeRegion.id,
        });
        setRegionTours(response.data);
        console.log("Fetched tours for region ID:", activeRegion.id, response.data);
      } catch (error) {
        console.error("Failed to fetch region tours:", error);
      }
    };
    // window.scrollTo(0, 0);
    fetchToursByRegion();
  }, [activeRegion]);

  // Fetch regions
  useEffect(() => {
    const fetchCountriesAndRegions = async () => {
      try {
        const response = await axios.get("/getcoutryregion");
        console.log("🌍 Country & Region Data:", response.data);

        const top10Regions = (response.data || [])
          .slice(0, 10)
          .map((item, index) => ({
            id: item._id || index,
            title: item.name,
            image: item.image,
            totalPackages: item.totalPackages || 0,
          }));

        setRegions(top10Regions);

        if (top10Regions.length > 0) {
          setActiveRegion(top10Regions[0]);
        }
      } catch (error) {
        console.error(" Failed to fetch country-region data:", error);
      }
    };
    window.scrollTo(0, 0);
    fetchCountriesAndRegions();
  }, []);

  return (
    <div className="bg-white px-4 py-6">
      {/* Region Tabs */}
      <div className="flex flex-wrap gap-4 border-b border-gray-300 pb-4 mb-6">
        {regions.map((region) => (
          <button
            key={region.id}
            onClick={() => setActiveRegion(region)}
            className={`px-4 py-2 text-lg font-semibold rounded-full transition ${
              activeRegion?.id === region.id
                ? "bg-blue-600 text-white"
                : "bg-gray-100 text-gray-800 hover:bg-blue-100"
            }`}
          >
            {region.title}
          </button>
        ))}
      </div>

      {/* Selected Region Info */}
      {/* {activeRegion && (
        <div className="mt-6">
          <h2 className="text-xl font-bold">{activeRegion.title}</h2>
          <p>Total Packages: {activeRegion.totalPackages}</p>
          {activeRegion.image && (
            <img
              src={activeRegion.image}
              alt={activeRegion.title}
              className="mt-4 max-w-xs rounded-md"
            />
          )}
        </div>
      )} */}

      {/* Region Tours Grid */}
      {regionTours.length > 0 && (
        <div className="mt-10">
          <h3 className="text-2xl font-bold mb-6 text-gray-800">
            Tours from {activeRegion.title}
          </h3>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {/* First Tour Large */}
            <Link
              to={`/tours/${regionTours[0]?._id}`}
              className="relative rounded-3xl overflow-hidden shadow-lg h-[500px] block"
            >
              <img
                src={regionTours[0]?.img}
                alt={regionTours[0]?.title}
                className="w-full h-full object-cover"
              />
              <div className="absolute bottom-0 w-full bg-gradient-to-t from-black to-transparent p-6">
                <h3 className="text-3xl text-white font-bold">
                  {regionTours[0]?.title}
                </h3>
                {/* <p className="text-white mt-1">{regionTours[0]?.region}</p> */}
              </div>
            </Link>

            {/* Smaller Cards */}
            <div className="grid grid-cols-3 gap-4">
              {regionTours.slice(1, 7).map((tour) => (
                <Link
                  to={`/tours/${tour._id}`}
                  key={tour._id}
                  className="relative h-48 rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition"
                >
                  <img
                    src={tour.img}
                    alt={tour.title}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute bottom-0 w-full bg-gradient-to-t from-black to-transparent p-3">
                    <h3 className="text-sm sm:text-base font-semibold text-white">
                      {tour.title}
                    </h3>
                    {/* <p className="text-xs sm:text-sm text-white">{tour.region}</p> */}
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RegionExplorer;